(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  // Quote Page Redirect (referenced from inline onclick handlers in the markup)
  window.redirectToQuote = function (quoteUrl, productTitle, productId, productUrl, variantId) {
    if (!quoteUrl) {
      console.error('Quote page URL not configured');
      alert('Quote page URL not configured. Please contact support.');
      return;
    }

    // Build URL with parameters
    const params = new URLSearchParams({
      product: productTitle,
      product_id: productId,
      product_url: productUrl,
      variant_id: variantId
    });

    // Redirect to quote page with parameters
    window.location.href = `${quoteUrl}?${params.toString()}`;
  };

  function initProductSection(root) {
    const sectionId = root.dataset.section;
    if (!sectionId) return;

    // Product media is rendered into a JSON <script> tag to keep this file Liquid-free.
    let productMedia = [];
    const mediaEl = document.getElementById('ProductMediaData-' + sectionId);
    if (mediaEl) {
      try { productMedia = JSON.parse(mediaEl.textContent); } catch (e) { productMedia = []; }
    }

    // Shipping Timer Countdown to 3pm ET
    const initShippingTimer = () => {
      const timerContainer = document.querySelector(`#shipping-timer-${sectionId}`);
      const countdownEl = document.querySelector(`#countdown-${sectionId}`);
      if (!timerContainer || !countdownEl) return;

      const updateCountdown = () => {
        // Get current time in ET
        const now = new Date();
        const etTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const currentHour = etTime.getHours();

        // Only show timer between 1am (1) and 3pm (15) ET
        if (currentHour < 1 || currentHour >= 15) {
          timerContainer.style.display = 'none';
          return;
        } else {
          timerContainer.style.display = 'block';
        }

        // Set target to 3pm ET today
        const target = new Date(etTime);
        target.setHours(15, 0, 0, 0); // 3pm ET

        // Calculate time difference
        const diff = target - etTime;

        if (diff <= 0) {
          countdownEl.textContent = '0h 0m 0s';
          timerContainer.style.display = 'none';
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        countdownEl.textContent = `${hours}h ${minutes}m ${seconds}s`;
      };

      // Update immediately and then every second
      updateCountdown();
      setInterval(updateCountdown, 1000);
    };

    // Image Lightbox Setup
    const initImageLightbox = () => {
      const mainImage = document.querySelector(`#MainImageSrc-${sectionId}`);
      const lightbox = document.querySelector(`#imageLightbox-${sectionId}`);
      const lightboxImage = document.querySelector(`#lightboxImage-${sectionId}`);
      const closeBtn = document.querySelector(`#closeLightboxBtn-${sectionId}`);

      const openLightbox = () => {
        if (mainImage && lightbox && lightboxImage) {
          const fullImageSrc = mainImage.dataset.fullSrc || mainImage.src;
          lightboxImage.src = fullImageSrc;
          lightboxImage.alt = mainImage.alt;
          lightbox.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      };

      const closeLightbox = () => {
        if (lightbox) {
          lightbox.classList.remove('active');
          document.body.style.overflow = '';
        }
      };

      // Click image to open lightbox
      if (mainImage) {
        mainImage.addEventListener('click', () => {
          openLightbox();
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeLightbox();
        });
      }

      if (lightbox) {
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox) {
            closeLightbox();
          }
        });
      }

      // ESC key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox && lightbox.classList.contains('active')) {
          closeLightbox();
        }
      });
    };

    // Thumbnail Gallery Handler
    const initThumbnails = () => {
      root.querySelectorAll('.amazon-thumbnail').forEach(thumb => {
        thumb.addEventListener('click', function () {
          root.querySelectorAll('.amazon-thumbnail').forEach(t => t.classList.remove('active'));
          this.classList.add('active');

          const mediaId = this.dataset.mediaId;
          const media = productMedia.find(m => m.id == mediaId);

          if (media && media.src) {
            const mainImage = document.querySelector(`#MainImage-${sectionId} img`);
            if (mainImage) {
              // The main image uses a responsive srcset; srcset takes precedence
              // over src, so clear it before swapping or the image won't change.
              mainImage.removeAttribute('srcset');
              mainImage.removeAttribute('sizes');
              mainImage.src = media.src.replace(/\.(jpg|png|jpeg)/g, '_800x.$1');
              mainImage.alt = media.alt || '';
            }
          }
        });
      });
    };

    // Price Display Update Handler
    const updatePriceDisplay = (variantPrice, variantComparePrice, variantAvailable) => {
      const priceWhole = Math.floor(variantPrice / 100);
      const priceDecimal = (variantPrice % 100).toString().padStart(2, '0');

      // Update all price blocks
      document.querySelectorAll(`[data-price-block-${sectionId}]`).forEach(priceBlock => {
        const priceWholeEl = priceBlock.querySelector('[data-price-whole]');
        const priceDecimalEl = priceBlock.querySelector('[data-price-decimal]');
        const discountBadgeEl = priceBlock.querySelector('[data-discount-badge]');
        const comparePriceEl = priceBlock.querySelector('[data-compare-price]');

        if (priceWholeEl) priceWholeEl.textContent = priceWhole;
        if (priceDecimalEl) priceDecimalEl.textContent = priceDecimal;

        // Handle discount display
        if (variantComparePrice && parseInt(variantComparePrice) > variantPrice) {
          const discountPercent = Math.round(((parseInt(variantComparePrice) - variantPrice) * 100) / parseInt(variantComparePrice));
          const compareFormatted = `${Math.floor(parseInt(variantComparePrice) / 100)}.${(parseInt(variantComparePrice) % 100).toString().padStart(2, '0')}`;

          if (discountBadgeEl) {
            discountBadgeEl.textContent = `-${discountPercent}%`;
            discountBadgeEl.style.display = 'inline-block';
          }
          if (comparePriceEl) {
            comparePriceEl.textContent = `List: $${compareFormatted}`;
            comparePriceEl.style.display = 'block';
          }
        } else {
          if (discountBadgeEl) discountBadgeEl.style.display = 'none';
          if (comparePriceEl) comparePriceEl.style.display = 'none';
        }
      });

      // Update stock status
      const stockStatusEl = document.querySelector(`#stock-status-${sectionId}`);
      if (stockStatusEl) {
        const isAvailable = variantAvailable === 'true' || variantAvailable === true;
        stockStatusEl.innerHTML = `<div class="amazon-stock" style="color: ${isAvailable ? '#007600' : '#B12704'};">${isAvailable ? 'In Stock' : 'Out of Stock'}</div>`;
      }

      // Update cart buttons
      root.querySelectorAll('.amazon-add-to-cart').forEach(btn => {
        const isAvailable = variantAvailable === 'true' || variantAvailable === true;
        btn.disabled = !isAvailable;
        btn.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
      });
    };

    // Variant Selection Handler
    const initVariantSelection = () => {
      root.querySelectorAll('.amazon-variant-btn, .amazon-color-swatch').forEach(btn => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Update UI
          const parent = this.closest('.amazon-variant-picker > div');
          parent.querySelectorAll('.amazon-variant-btn, .amazon-color-swatch').forEach(b => b.classList.remove('selected'));
          this.classList.add('selected');

          // Get variant data
          const { variantId, variantPrice, variantComparePrice, variantAvailable } = this.dataset;

          if (variantId && variantPrice) {
            // Update price
            updatePriceDisplay(parseInt(variantPrice), variantComparePrice, variantAvailable);

            // Update forms
            document.querySelectorAll(`#MainProduct-${sectionId} input[name="id"]`).forEach(input => {
              input.value = variantId;
            });

            // Update URL
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url);

            // Dispatch change event
            const event = new Event('change', { bubbles: true });
            document.querySelector(`#MainProduct-${sectionId} input[name="id"]`)?.dispatchEvent(event);
          }
        });
      });
    };

    // Buy Now: add the current variant to the cart and go straight to checkout
    const initBuyNow = () => {
      const section = document.querySelector(`#MainProduct-${sectionId}`);
      if (!section) return;
      const buyNowBtn = section.querySelector('[data-buy-now]');
      if (!buyNowBtn) return;

      // Remember the pristine state so we can restore it if the page is
      // returned from the back/forward cache mid-checkout.
      const initialLabel = buyNowBtn.textContent.trim();
      const initiallyDisabled = buyNowBtn.disabled;

      const resetBuyNow = () => {
        buyNowBtn.textContent = initialLabel;
        buyNowBtn.disabled = initiallyDisabled;
      };

      // When the user clicks Buy Now we redirect to /checkout. Hitting the
      // back button restores this page from bfcache with the button still
      // showing "Processing...". pageshow fires on that restore, so reset it.
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) resetBuyNow();
      });

      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();

        const variantInput = section.querySelector('input[name="id"]');
        const variantId = variantInput ? variantInput.value : null;
        if (!variantId) {
          console.error('[Buy Now] No variant ID found');
          return;
        }

        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Processing...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(response => {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error('[Buy Now] Error:', error);
            buyNowBtn.textContent = 'Error - Try Again';
            setTimeout(resetBuyNow, 2000);
          });
      });
    };

    initShippingTimer();
    initImageLightbox();
    initThumbnails();
    initVariantSelection();
    initBuyNow();
  }

  const initAll = () => {
    document.querySelectorAll('.product-amazon-layout[data-section]').forEach(initProductSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
